import { IconChart, IconClipboard, IconDumbbell } from './icons';

const TABS = [
  { id: 'train', Icon: IconDumbbell },
  { id: 'progress', Icon: IconChart },
  { id: 'program', Icon: IconClipboard },
];

export default function BottomNav({ activeTab, onChange, t }) {
  const labels = {
    train: t.navTrain,
    progress: t.navProgress,
    program: t.navProgram,
  };

  return (
    <nav className="bottom-nav" aria-label="Primary">
      {TABS.map(({ id, Icon }) => (
        <button
          key={id}
          type="button"
          className={`bottom-nav-item${activeTab === id ? ' is-active' : ''}`}
          onClick={() => onChange(id)}
          aria-current={activeTab === id ? 'page' : undefined}
        >
          <Icon size={22} />
          <span>{labels[id]}</span>
        </button>
      ))}
    </nav>
  );
}
